import React, { useRef, useEffect } from "react";
import "./Experience2.css";
import SS1 from "../images/ss1.jpg";
import Reel2 from "../videos/Reel2.mp4";
import SS3 from "../images/ss3.jpg";

export default function Experience2() {
  const videoRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
          video?.play();
        } else {
          video?.pause();
        }
      },
      { threshold: 0.8 }
    );

    if (video) observer.observe(video);

    return () => {
      if (video) observer.unobserve(video);
    };
  }, []);

  useEffect(() => {
    const el = textRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove('animate-in');
          void el.offsetWidth;
          el.classList.add('animate-in');
        }
      },
      { threshold: 0.5 }
    );

    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section className="experience2-page">
      <div className="experience2-content">
        <div className="exp2-images">
          <img src={SS1} alt="Experience Left" className="exp2-img img-back-left" />
          <video
            ref={videoRef}
            src={Reel2}
            className="exp2-img img-mid box-shadow"
            controls
            autoPlay
            muted
            loop
            playsInline
          />
          <img src={SS3} alt="Experience Right" className="exp2-img img-back-right" />
        </div>

        <div className="exp2-text" ref={textRef}>
          <h4>Experiences</h4>
          <h2>
            Luxury Meets<br />Everyday Living
          </h2>
          <p>
            From timeless designs to modern innovations, our furniture blends
            style and substance. Each piece is made with premium materials and
            unmatched expertise, bringing a touch of luxury to your everyday life.

          </p>

          <div className="exp2-instagram-plain">
            <a
              href="https://www.instagram.com/jooloo.in?utm_source=ig_web_button_share_sheet&igsh=MTl3cnp2a2ZsMXEyNQ=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                className="exp2-instagram-img"
              />
              <span className="exp2-instagram-text">Follow Us</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
